import React, { FC } from 'react'
import { SectionFullWidthMediaProps } from '@sans-souci/models'
import { Media, SectionWrap } from '@sans-souci/components'

export const SectionFullWidthMedia: FC<SectionFullWidthMediaProps> = ({
  media,
  priority,
  _key,
}) => {
  return (
    <SectionWrap type={'fullBleed'} id={_key}>
      {media && <Media {...media} layout={'responsive'} priority={priority} />}
    </SectionWrap>
  )
}
